import React from 'react';
import { I18n } from 'react-redux-i18n';

import { useAppSelector } from '../../../../hooks/redux/useApp';
import { getValue } from '../../../../components/template/templateHelper';
import { AnnouncementBanner } from '../../../../components/common/announcementBanner';
import {
  ProgramAnnouncement,
  toActiveAnnouncement
} from '../../helpers/announcement';
import { paths } from '../constants/template';

interface AnnouncementPreviewProps {
  /** Read by the template builder so it renders this element as it is. */
  isolated?: boolean;
}

/**
 * Live preview of the banner charities will see, fed from the template
 * builder's unsaved values so the admin can check the wording before saving.
 */
export const AnnouncementPreview: React.FC<AnnouncementPreviewProps> = () => {
  const announcement = useAppSelector(
    (state) =>
      getValue(state.templateBuilderEx, paths.ANNOUNCEMENT) as
        | ProgramAnnouncement
        | undefined
  );
  const active = announcement ? toActiveAnnouncement(announcement) : null;

  if (!active) {
    return (
      <p data-testid="announcement-preview-empty">
        {I18n.t('programs.template.page.announcements.preview.empty')}
      </p>
    );
  }

  return (
    <AnnouncementBanner
      live={false}
      testId="announcement-preview"
      title={active.title}
      body={active.description}
      link={active.callToAction}
    />
  );
};

export default AnnouncementPreview;
